export const generateRange = (from: number, to: number) => {
  if (isNaN(from) || isNaN(to) || from > to || to === 0) return []

  return new Array(to - from + 1).fill(0).map((_, index) => from + index)
}
